const filterCollections = {
  'filter-collections-breadcrumbs': 'Коллекции фильтров',
  'filter-collections-form-groups-field': 'Группы',
  'filter-collections-form-groups-hint': 'Группы отображаются слева направо по порядку в списке приоритета (верхний = крайний слева)',
  'filter-collections-form-groups-placeholder': 'Выберите группы',
  'filter-collections-groups-priority': 'Приоритет групп',
  'filter-collections-groups-priority-help': 'Установить желаемый порядок групп',
  'filter-collections-groups-not-selected': 'Группы не выбраны',
  'filters-filter-collection-title': 'Коллекция групп',
};

export default filterCollections;
